import React, { useMemo } from 'react';
import { useClassNames } from 'hooks/useClassNames';
import { Button, ButtonProps } from 'primereact/button';
import { PButtonLinkStyle as S } from './PButtonLink.style';
import * as iconsLibrary from '../../Icon/icons.library';
import { Icon } from 'components/Icon/Icon';
import { PButtonAsProps, PButtonAsWrapper } from './PButton';

type PButtonLinkProps = Omit<ButtonProps, 'severity' | 'size' | 'icon' | 'label' | 'loading'> & {
  label?: React.ReactNode;
  severity?: 'primary' | 'secondary' | 'invert';
  icon?: keyof typeof iconsLibrary;
} & PButtonAsProps;

export const PButtonLink = React.forwardRef<Button, PButtonLinkProps>((props, ref) => {
  const classNames = useClassNames(
    {
      [`button-link-severity-${props.severity || 'primary'}`]: true,
    },
    props.className
  );
  const cleanProps = useMemo(
    () => (({ severity, label, icon, as, to, href, target, rel, ...p }) => p)(props),
    [props]
  );
  return (
    <PButtonAsWrapper
      as={props.as}
      to={props.to}
      href={props.href}
      target={props.target}
      rel={props.rel}
      disabled={props.disabled}
    >
      <S.ButtonLink type="button" {...cleanProps} className={classNames} ref={ref}>
        <div className="button-link-custom-wrapper">
          {props.children || (
            <>
              <span className="button-link-custom-label">{props.label}</span>
              {props.icon && (
                <span className="button-link-custom-icon-wrapper">
                  <Icon icon={props.icon} />
                </span>
              )}
            </>
          )}
        </div>
      </S.ButtonLink>
    </PButtonAsWrapper>
  );
});
